import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeProfileData } from '../../../../redux/actions/pages/user/login';
import { handleChangeInputProilePage } from '../../../../redux/actions/pages/user/profile';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, EDIT_PROFILE_POST } from '../../../../apis'; 
import { Row, Col } from 'react-bootstrap';
import Collapse from '@mui/material/Collapse';
import imageCompression from 'browser-image-compression';

const Profile = () => {

    const dispatch = useDispatch();

    const { token, profile } = useSelector(state => state.login);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);
    const { title, logo, fname, lname, address } = useSelector(state => state.profile);

	const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);
    const [boxCollapsed, setBoxCollapsed] = React.useState(false);
    const handleBoxCollapsed = () => {
        setBoxCollapsed((prev) => !prev);
    };

    useEffect(() => {
        dispatch(handleChangeInputProilePage('title', profile.title));
        dispatch(handleChangeInputProilePage('fname', profile.fname));
        dispatch(handleChangeInputProilePage('lname', profile.lname));
        dispatch(handleChangeInputProilePage('address', profile.address));

        setBoxCollapsed(true);
    }, [Profile]);


    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputProilePage(name, value));
    };



    const handelChangeFile = async (event) => {
        // dispatch(handleChangeInstallmentsUploadFactorPage('file', event.target.files[0]));

        const selectedFile = event.target.files[0];
        if (!selectedFile) return;


        if (selectedFile.size > 200 * 1024) {
            const options = {
                maxSizeMB: 0.2, // فشرده‌سازی به حدود 200KB
                useWebWorker: true,
            };
            try {
                const compressedBlob = await imageCompression(selectedFile, options);
                const compressedFile = new File(
                    [compressedBlob],
                    selectedFile.name, // اینجا نام و پسوند اصلی حفظ می‌شه
                    { type: selectedFile.type }
                );
                dispatch(handleChangeInputProilePage('logo', compressedFile));
            } catch (err) {
                dispatch(handleChangeInputProilePage('logo', selectedFile));
            }
        } else {
            dispatch(handleChangeInputProilePage('logo', selectedFile));
        }
    };


    const handleSubmitForm = async () => {
        if(! isBackdropLoading) {
            if (!logo && logo === null) {
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا  لوگو را انتخاب کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                return;
            }

            dispatch(handleSetBackdropLoading(true));


            const formData = new FormData();
            formData.append('logo', logo);
            formData.append('title', title);
            formData.append('fname', fname);
            formData.append('lname', lname);
            formData.append('address', address);

            try {
                dispatch(handleSetBackdropLoading(true));

                const response = await fetch(BASE_SITE + EDIT_PROFILE_POST, {
                    method: 'POST',
                    headers: {
                        'Authorization': token, 
                    },
                    body: formData,
                });

                const result = await response.json();

                if(response.ok) {
                    if(result.status === 'ok') {
                        dispatch(handleSetOpenCustomSnackbar(true, {message: 'پروفایل شما با موفقیت ویرایش شد', severity: 'success', vertical: 'top', horizontal: 'center'}));  

                        let newProfile = {...profile};
                        newProfile.title = title;
                        newProfile.logo = result.logo;
                        newProfile.fname = fname;
                        newProfile.lname = lname;
                        newProfile.address = address;
                        dispatch(handleChangeProfileData(newProfile));
                    }
                    else if(result.status === 'error') {
                        dispatch(handleSetOpenCustomSnackbar(true, {message: result.message, severity: 'error', vertical: 'top', horizontal: 'center'}));  
                    }
                }
                else {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                }
                dispatch(handleSetBackdropLoading(false));
            } catch (err) {
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                dispatch(handleSetBackdropLoading(false));
            } finally {
                dispatch(handleSetBackdropLoading(false));
            }
        }    
    };


    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};


    return (
        <div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">اطلاعات فروشگاه</h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className={boxCollapsed ? "icon-minus4" : "icon-plus4"} onClick={handleBoxCollapsed}></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <Collapse in={boxCollapsed} className="card-body collapse in">
                                    <div className="card-block">
                                        <div className="form-body" style={{overflow: 'unset !important'}} >
                                            <Row >
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">موبایل</label>
                                                    <input type="number" name="mobile" class="form-control" id="input-mobile" value={profile.mobile} disabled="disabled" />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">نام فروشگاه</label>
                                                    <input type="text" name="title" class="form-control" id="input-title" onChange={handleChangeInputs} value={title} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">نام</label>
                                                    <input type="text" name="fname" class="form-control" id="input-fname" onChange={handleChangeInputs} value={fname} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">نام خانوادگی</label>
                                                    <input type="text" name="lname" class="form-control" id="input-lname" onChange={handleChangeInputs} value={lname} />
                                                    <p class="text-danger"></p>
                                                </div>
                                            </Row>

                                            <Row >
                                                <div class="form-group col-md-9">
                                                    <label class="c-label">آدرس</label>
                                                    <input type="text" name="address" class="form-control" id="input-address" onChange={handleChangeInputs} value={address} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">لوگو</label>
                                                    <input type="file" name="logo" class="form-control" id="input-logo" onChange={handelChangeFile} accept="image/*"  />
                                                    <p>
                                                        <img src={profile.logo} height={100} />
                                                    </p>
                                                    <p class="text-danger"></p>
                                                </div>
                                            </Row>

                                        </div>
                                    </div>

                                    <div class="card-body collapse in">
                                        <div class="card-block">
                                            <div class="form-actions">
                                                <button type="submit" class="btn btn-success" name="add_btn" value="add" onClick={handleSubmitForm}>
                                                    <i class="icon-check2"></i> ویرایش
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </Collapse>
                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default Profile;